import '../../../src/CSS/loaders.css';
function MainLoader() {
  return (
    <div className="mainloader"></div>
);
}

export default MainLoader;